import React from "react";
import { ShimmerThumbnail } from "react-shimmer-effects";
const MessageDetailsLoader = () => {

  return (
    <>
      <div className="message-detail-card">
        <div className="d-flex align-items-center">
          <div style={{ width: '40px' }}><ShimmerThumbnail height={40} className="rounded-2 mb-0" /></div>
          <div className="mg-l-10 w-100">
            <div style={{ width: '60%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
            <div style={{ width: '100px' }}><ShimmerThumbnail height={8} className="rounded-5 mb-0" /></div>
          </div>
        </div>
        <div>
          <div style={{ width: '70px' }} className="mg-t-30"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '80%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '90%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '90px' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div>
          <div style={{ width: '60%' }} className="mg-t-15"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '80%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '90%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100px' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
        <div>
          <div style={{ width: '60%' }} className="mg-t-15"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '80%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '90%' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100px' }} className="mg-t-2"><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
      </div>
      <div className='message-attachment-item'>
        <div className='message-attachment-icon'>
          <div style={{ width: '20px' }}><ShimmerThumbnail height={20} className="rounded-2 mb-0" /></div>
        </div>
        <div className='message-attachment-name'>
          <div style={{ width: '60%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
      </div>
      <div className='message-attachment-item mg-t-15'>
        <div className='message-attachment-icon'>
          <div style={{ width: '20px' }}><ShimmerThumbnail height={20} className="rounded-2 mb-0" /></div>
        </div>
        <div className='message-attachment-name'>
          <div style={{ width: '60%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
      </div>
      <div className='message-attachment-item mg-t-15'>
        <div className='message-attachment-icon'>
          <div style={{ width: '20px' }}><ShimmerThumbnail height={20} className="rounded-2 mb-0" /></div>
        </div>
        <div className='message-attachment-name'>
          <div style={{ width: '60%' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
          <div style={{ width: '100px' }}><ShimmerThumbnail height={12} className="rounded-5 mb-0" /></div>
        </div>
      </div>
    </>
  )
}

export default MessageDetailsLoader;